export default {
  "ORDER_WAIT_SHIP": "In attesa di spedizione",
  "Men fashion": "Abbigliamento uomo",
  "MyAccount_MyProfile_label_First": "Nome",
  "MyAccount_MyShippingDetails_Phone": "Numero di telefono",
  "Page_not_found_message1": "Spiacenti, non è possibile trovare questa pagina",
  "Help": "Aiuto",
  "Sign in": "Accedi",
  "Register": "Registrati",
  "Category_sorting_Item": "Seleziona il metodo di ordinamento",
  "cart_clear": "Svuota carrello",
  "Payment & Delivery": "Pagamento e consegna",
  "Send my feedback": "Invia il mio feedback",
  "MyAccount_MyProfile_Save": "Salva modifiche",
  "Continue_billing": "Continua il pagamento",
  "Categories": "Categorie",
  "Read and understand": "Ho letto e compreso",
  "Feel free to edit": "Modifica liberamente qualsiasi dettaglio del tuo account per mantenerlo sempre aggiornato",
  "Select payment method": "Seleziona il metodo di pagamento",
  "Login_input_email": "La tua email",
  "Login_input_first": "Nome",
  "Account": "Account",
  "Create_Time_Asc": "Data di creazione (crescente)",
  "concactus_label": "Opinioni o domande",
  "Order_Grade": "Voto dell'ordine",
  "wishlist_empty_desc": "Sembra che non hai ancora aggiunto prodotti nel carrello. Inizia a fare acquisti!",
  "cartpreviewShipping_messageinfo": "Riceverai una conferma di spedizione e una data di arrivo",
  "unsubscribe": "Puoi disiscriverti in qualsiasi momento",
  "prompt": "Prompt",
  "MyAccount_MyProfile_yinsi_message": "In Brand name ci preoccupiamo molto della tua privacy e ci impegniamo a proteggere i tuoi dati personali. Per maggiori informazioni su come ci prendiamo cura e utilizziamo i tuoi dati personali, consulta",
  "About us": "Chi siamo",
  "or": "oppure",
  "MyAccount_Order_History_All": "Tutti gli ordini",
  "What_We_Improve": "Cosa possiamo migliorare?",
  "MyAccount_ShippingDetails_title": "Dettagli di spedizione",
  "MyAccount_Order_History_Tabs2": "Pagamenti in sospeso",
  "Go_back_shopping": "Torna a fare acquisti",
  "Product": "Prodotto",
  "Order summary": "Sommario dell'ordine",
  "payment_order_total": "Totale dell'ordine",
  "Departments": "Dichiarazione legale",
  "Download": "Scarica",
  "Your_Purchase_Order": "Il tuo ordine",
  "Your_Account": "Il tuo account",
  "order_after_sales_list_null": "Al momento non hai ordini post-vendita",
  "All_After_sales_orders": "Tutti gli ordini post-vendita",
  "Filters": "Filtri",
  "search_results_not": "Non abbiamo trovato risultati relativi al tuo termine di ricerca",
  "ORDER_WAIT_RECEIPT": "In attesa di ricezione",
  "ORDER_CLOSED": "Chiuso",
  "Order_View_details": "Visualizza dettagli",
  "Subscribe_to_message": "Mantieniti aggiornato sui prossimi saldi e gli eventi. Accedi a omaggi e offerte speciali!",
  "TaxFee": "Tasse",
  "Apply": "Applica",
  "Total_price": "Prezzo totale",
  "Description": "Descrizione",
  "Payment method": "Metodo di pagamento",
  "Back": "Indietro",
  "Empty": "Sembra che non hai ancora aggiunto prodotti nel carrello. Inizia a fare acquisti per riempirlo.",
  "After_sales": "Ordini post-vendita",
  "Instruction3": "Sì, lo sappiamo",
  "MyAccount_MyShippingDetails_Last": "Cognome",
  "MyAccount_MyShippingDetails_City": "Città",
  "payment_order_discount": "Sconto dell'ordine",
  "MyAccount_Order": "Dettagli dell'ordine",
  "ID_Name_Error": "Inserisci il nome del tuo documento d'identità",
  "Kidswear": "Abbigliamento per bambini",
  "Share your look": "Condividi il tuo stile",
  "Pay_Order": "Paga l'ordine",
  "Reset_Password": "Reimposta la password",
  "MyAccount_MyProfile_label2_pass1": "Password corrente",
  "Create_Time_Desc": "Data di creazione (decrescente)",
  "Items": "Articoli",
  "Login_Register": "Registrati subito",
  "Back to homepage": "Torna alla homepage",
  "switch_CNY": "Passa a RMB",
  "Successful placed order": "Il tuo ordine è stato effettuato con successo. Puoi controllare lo stato dell'ordine utilizzando la funzione di stato della consegna. Riceverai una email di conferma dell'ordine contenente i dettagli dell'ordine e il collegamento per il monitoraggio.",
  "MyAccount_MyProfile_yinsi_link": "Politica sulla privacy",
  "Order_Date": "Data dell'ordine",
  "Allow order notifications": "Consenti notifiche dell'ordine",
  "MyAccount_MyProfile_Tab1": "Profilo personale",
  "MyAccount_ShippingDetails_changeTitle": "Modifica indirizzo",
  "ID_Number": "Numero di identificazione",
  "Order_after_sales_message": "Ordini e ordini post-vendita",
  "MyAccount_MyProfile_title2": "Per modificare la password per accedere al tuo account, inserisci le seguenti informazioni:",
  "Customer service": "Servizio clienti",
  "MyAccount_MyProfile_Update": "Aggiorna la password",
  "choose_language": "Scegli la lingua",
  "ORDER_REFUNDING": "Rimborso in corso",
  "MyAccount_MyProfile_title1": "Modifica liberamente qualsiasi dettaglio del tuo account per mantenerlo sempre aggiornato",
  "ORDER_WAIT_RATE": "In attesa di recensione",
  "after_sales_refund_order": "Rimborso dell'ordine",
  "Who we are": "Chi siamo",
  "Women fashion": "Abbigliamento donna",
  "Cookies Policy": "Politica sui Cookie",
  "Clear all": "Cancella tutto",
  "Basket": "Cestino",
  "MyAccount_MyProfile_reqeatPassErrMsg": "La nuova password non coincide",
  "Your current email address is": "Il tuo indirizzo email corrente è",
  "You currently have no orders": "Attualmente non hai ordini",
  "Login_input_password": "Password",
  "Promo_code": "Codice promozionale",
  "order_count": "Numero di ordine",
  "Personal details": "Dettagli personali",
  "Password": "Password",
  "wishlist_empty_title": "Il tuo carrello è vuoto",
  "Repeat_Password": "Ripeti password",
  "cart_price": "Totale parziale",
  "Sort_by": "Ordina per",
  "Customer Reviews": "Recensioni dei clienti",
  "Continue to shipping": "Procedi al pagamento",
  "payment_make_order": "Effettua l'ordine",
  "save_order_review": "Invia recensione",
  "Save_Password": "Salva password",
  "cart_empty_title": "Il tuo carrello è vuoto",
  "TopBar_help": "Aiuto e FAQ",
  "colseCookie": "OK",
  "Password_Changed": "La password è stata modificata con successo. Ora puoi tornare alla home page e accedere.",
  "Forgot Password Modal Email": "Il tuo indirizzo e-mail di accesso:",
  "MyAccount_Personal": "Dettagli personali",
  "cartPreviewShipping": "Spedizione",
  "ORDER_AFTER_SALE": "Post-vendita",
  "Page_not_found": "Pagina non trovata",
  "Find out more": "Maggiori informazioni",
  "Log into your account": "Accedi al tuo account",
  "Details_and_status_orders": "Controlla il dettaglio e lo stato del tuo ordine online. Puoi anche cancellare l'ordine o richiedere restituzione. ",
  "Order_to_be_paid_message": "In attesa di pagamento",
  "Guarantee": "Garanzia",
  "Sections that interest you": "Le sezioni che ti interessano",
  "payment_post_tax": "Imposta sulla spedizione",
  "ORDER_PAID": "Pagato",
  "concactus_label5": "Trattamento",
  "Item": "Oggetto",
  "Go_back": "Torna indietro",
  "more": "Altro",
  "MyAccount": "Il mio account",
  "payment_agree_1": "Accetto",
  "total_items": "Totale prodotti",
  "shopping_go": "Gestisci gli indirizzi",
  "ID_Type": "Tipo di documento d'identità",
  "after_sales_status": "Stato post-vendita",
  "After_sales_apply": "Richiedi restituzione",
  "Login": "Accedi",
  "Quantity": "Quantità",
  "payment_post_fee": "Spese di spedizione",
  "MyAccount_Log_out": "Esci",
  "Subtotal": "Totale parziale",
  "forgotPasswordConfirmation": "Grazie! Se l'account è stato registrato con un indirizzo email {0}, troverai un messaggio nella tua casella di posta con un link per reimpostare la password.",
  "MyAccount_Order_History_Tabs1": "I miei ordini",
  "concactus_img": "Carica immagine",
  "Done": "Fatto",
  "Info after order": "Puoi accedere al tuo account utilizzando l'indirizzo email e la password definiti in precedenza. Nel tuo account puoi modificare il tuo profilo, visualizzare la cronologia degli acquisti, gestire le notifiche e tanto altro.",
  "MyAccoubnt_Set_newsletter": "Configura per ricevere le nostre newsletter, scopri i nuovi trend e i prodotti della settimana scelti apposta per te.",
  "Shipping_method": "Modalità di spedizione",
  "after_sales_refund": "Importo del rimborso",
  "After_sales_save": "Salva le informazioni post-vendita",
  "go_order_history": "Vedi la cronologia degli ordini",
  "contactus_message_placeholder": "Inserisci i tuoi commenti o le tue domande",
  "Login_Forgot_Password": "Se non ti ricordi la password, puoi reimpostarla",
  "show_more": "Mostra di più",
  "MyAccount_MyProfile_label_email": "Il tuo indirizzo e-mail",
  "MyAccount_MyProfile_label2_pass3": "Ripeti password",
  "Products": "Prodotti",
  "Review": "Recensione",
  "MyAccount_MyProfile_title3": "Il tuo indirizzo e-mail corrente è il seguente:",
  "Category_found_Products": "Prodotti trovati",
  "Match": "Match",
  "Read_all_reviews": "Leggi tutte le recensioni",
  "Commercial information": "Acconsento a ricevere e-mail di informazione commerciale personalizzata dal nome del marchio",
  "Change password your account": "Se vuoi modificare la password di accesso al tuo account, inserisci le informazioni sottostanti",
  "ID_Name": "Nome sul documento d'identità",
  "All": "Tutto",
  "Instruction2": "Hai solo bisogno delle istruzioni per la cura del prodotto?",
  "MyAccount_ShippingDetails_Add": "Aggiungi un nuovo indirizzo",
  "MyAccount_MyShippingDetails_Zip": "CAP",
  "go_pay_order": "Vai al pagamento",
  "Thank_You_Inbox": "Se il messaggio non è arrivato nella tua casella di posta, prova ad utilizzare un altro indirizzo email che hai eventualmente utilizzato per la registrazione.",
  "Subscribe": "Iscriviti",
  "confirm_subscription": "Confermo la mia iscrizione",
  "Login_input_Remember": "Ricordami",
  "Add to compare": "Aggiungi al confronto",
  "Brand": "Brand",
  "Start_shopping": "Inizia lo shopping",
  "Select shipping method": "Seleziona la modalità di spedizione",
  "address CN": "L'indirizzo di spedizione è in Cina, la valuta corrente deve essere ¥ RMB",
  "MyAccount_MyShippingDetails_State": "Stato/Provincia",
  "Page_not_found_message2": "Torna alla pagina precedente o riprova",
  "Go_to_checkout": "Vai al checkout",
  "See all results": "Vedi tutti i risultati",
  "search_results_inputnull": "Non hai ancora cercato prodotti.",
  "subscribeToNewsletterModalContent": "Con l'iscrizione alla newsletter riceverai offerte esclusive e promozioni personalizzate dal Brand Name per e-mail. Non venderemo o distribuiremo mai il tuo indirizzo e-mail a terzi. Leggi la nostra {0}.",
  "Download all": "Scarica tutto",
  "Login_input_last": "Cognome",
  "Amount": "Importo",
  "ORDER_WAIT_PAYMENT": "In attesa di pagamento",
  "Order_After_sales": "Ordine di assistenza post-vendita",
  "concattus_button": "Invia",
  "Shipping_valid_required": "Campo obbligatorio",
  "Price": "Prezzo",
  "ID_Type_Error": "Selezionare il tipo di documento d'identità",
  "Order_Status": "Stato dell'ordine",
  "Payment methods": "Metodi di pagamento",
  "MyAccount_MyProfile_Tab2": "Modifica password",
  "Show on page": "Mostra sulla pagina",
  "Edit": "Modifica",
  "Change": "Cambia",
  "MyAccount_ShippingDetails_Update": "Aggiorna indirizzo",
  "View": "Vedi",
  "Privacy": "Privacy",
  "Enter_promo_code": "Inserire codice promozionale",
  "Discount": "Sconto",
  "Delete": "Elimina",
  "Wishlist": "Lista dei desideri",
  "MyAccount_Order_History_Tabs3": "Reso",
  "Go_To_Order_review": "Vai alla recensione dell'ordine",
  "Update personal data": "Aggiorna i dati personali",
  "payment_agree_2": "Termini e condizioni",
  "or fill the details below": "O compilare i dettagli di seguito",
  "Contact details updated": "Mantenere aggiornati indirizzo e informazioni di contatto.",
  "Login_Create": "Crea account",
  "Payment": "Pagamento",
  "Billing": "Fatturazione",
  "payment_insurance_tax": "Assicurazione fiscale",
  "Size guide": "Guida alle taglie",
  "Login_forgotten_password": "Password dimenticata?",
  "Login_no_account": "Non hai un account?",
  "Privacy_Policy": "Informativa sulla privacy",
  "BootomCookieTitle": "Cookie consent",
  "Use your personal data": "Brand name valorizza la tua privacy e si impegna a proteggere i dati personali dei nostri utenti. Per maggiori informazioni su come ci prendiamo cura e utilizziamo i tuoi dati personali, consulta la nostra ",
  "Review my order": "Rivedi il mio ordine",
  "BootomCookieLink": "Scopri di più",
  "hide": "Nascondi",
  "MyAccount_ShippingDetails_message_title": "Gestisci tutti gli indirizzi di spedizione che desideri (luogo di lavoro, casa, etc.) in modo da non dover inserirli manualmente in ogni ordine.",
  "Purchase terms": "Condizioni di acquisto",
  "Billing_address": "Indirizzo di fatturazione",
  "Manage shipping addresses": "Gestisci tutti gli indirizzi di spedizione che desideri (luogo di lavoro, casa...) in modo da non dover inserirli manualmente in ogni ordine.",
  "login_logbtn": "Accedi",
  "choose_currency": "Seleziona valuta",
  "ORDER_REFUNDED": "Rimborsato",
  "After_sales_form": "Compila il modulo post vendita",
  "add_To_Wishlist": "Aggiungi alla lista dei desideri",
  "search_results_inputnull2": "Inizia ora, ti aiuteremo!",
  "Total": "Totale",
  "Subscribe_to_newsletter": "Iscriviti alla newsletter",
  "Shipping_valid_Phone": "Inserisci un numero di telefono valido",
  "concactus_label3": "Titolo",
  "Manage billing addresses": "Gestisci tutti gli indirizzi di fatturazione che desideri (luogo di lavoro, casa...) in modo da non dover inserirli manualmente in ogni ordine.",
  "Search_results_title": "Risultati della ricerca",
  "payment_order_payment": "Pagamento dell'ordine",
  "after_sales_Id": "ID post-vendita",
  "cart_title": "Il mio carrello",
  "Order_Detail": "Dettagli dell'ordine",
  "concactus_label2": "Link di negozio",
  "Shipping_valid_length_min": "Il campo dovrebbe avere almeno {min} caratteri",
  "Product suggestions": "Suggerimenti di prodotto",
  "Return_home": "Torna alla homepage",
  "Quality in the details": "Qualità nei dettagli",
  "Continue_to_payment": "Continua al pagamento",
  "Feedback": "Il tuo feedback è importante per noi. Per favore dicci cosa possiamo migliorare.",
  "Go back to shop": "Torna al negozio",
  "Back_to_home": "Torna alla homepage",
  "Review_Content": "Contenuto della recensione",
  "add_To_Cart": "Aggiungi al carrello",
  "Read_reviews": "Leggi le recensioni",
  "Instruction1": "Istructions Per la cura",
  "Email_address": "Indirizzo email",
  "Category_Item_List": "Passa alla visualizzazione elenco",
  "Same as shipping address": "Stesso dell'indirizzo di spedizione",
  "Category_Item_Grid": "Passa alla visualizzazione a griglia",
  "ID_Number_Error": "Inserisci il tuo numero di identificazione",
  "concactus_label4": "E-mail di contatto",
  "Additional_info": "Informazioni aggiuntive",
  "add_shipping": "Aggiungi nuovo indirizzo di spedizione",
  "Product_description": "Maglietta Karissa V-Neck con design semi-aderente, adatta a qualsiasi tipo di fisico. Si adatta alle curve del corpo, coprendo le aree problematiche comuni, permettendoti di andare in palestra con sicurezza. In alternativa, splendidi abiti da cocktail e v",
  "Login_create_account": "Crea un account",
  "after_sales_Reason": "Motivo della post-vendita",
  "MyAccount_MyProfile_label_Last": "Cognome",
  "MyAccount_MyProfile_label2_pass2": "Nuova password",
  "Save": "Salva",
  "CartSliderTextBtn": "Salva per acquistare dopo",
  "Color": "Colore",
  "Shipping_Tax": "Tasse di spedizione",
  "Subscribe_to_success": "Iscrizione effettuata",
  "Enjoy your free account": "Goditi i benefici dell'account gratuito!",
  "cart_empty_desc": "Non hai ancora aggiunto alcun prodotto al carrello. Inizia lo shopping per riempirlo.",
  "MyAccount_ShippingDetails_message_title2": "Mantenere aggiornati indirizzo e informazioni di contatto.",
  "An_error_occured": "Si è verificato un errore",
  "Country": "Paese",
  "MyAccount_MyShippingDetails_First": "Nome",
  "payment_insurance_fee": "Tassa assicurativa",
  "Home": "Home",
  "Contact_us": "Contattaci",
  "email_geshi_error": "Si prega di inserire un indirizzo email valido",
  "your_email": "La tua email",
  "email": "Email",
  "you_have_subscribed": "Ti sei iscritto",
  "cancel_Subscribe": "Annulla l'iscrizione",
  "save_and_pay": "Salva e paga",
  "hasInsurance": "Acquista l'assicurazione",
  "pleasePayType": "Seleziona il metodo di pagamento",
  "zhuanfa_toBePay": "Fai pagare da un amico",
  "linkCopied": "Link copiato, incollalo e condividilo con i tuoi amici",
  "Links": "Collegamenti",
  "article_category": "Categoria dell'articolo",
  "wechat_code_login_message": "Si prega di utilizzare WeChat per scansionare il codice QR per effettuare il login",
  "wechat_code_login": "Accesso tramite scansiona codice QR di WeChat",
  "Api_Update_success": "Aggiornamento riuscito",
  "Please_Use_WeChat_login": "Si prega di accedere utilizzando WeChat",
  "mobile_geshi_error": "Inserisci un numero di telefono valido",
  "Login_input_email_required": "Inserisci la tua email",
  "article_null": "Nessun articolo disponibile",
  "Login_with_microsoft": "Login Microsoft",
  "article_null_des": "Puoi sfogliare gli articoli in altre categorie",
  "register_email": "Registrazione email",
  "Login_tab_email": "Login email",
  "code.time": "Riprova tra {time} secondi",
  "Login_with_wechat": "Login WeChat",
  "cat_items_null_des": "Puoi sfogliare i prodotti in altre categorie",
  "Login_with_facebook": "Login Facebook",
  "Login_input_code": "Codice di verifica",
  "Login_input_mobile_required": "Inserisci il tuo numero di cellulare",
  "Login_input_mobile": "Il tuo numero di cellulare",
  "cat_items_null": "Nessun prodotto in questa categoria",
  "Login_with_twitter": "Login Twitter",
  "mobile_code": "Codice di verifica",
  "register_mobile": "Registrazione cellulare",
  "Login_tab_mobile": "Login cellulare",
  "Login_with_google": "Login Google",
  "OrderSku": "Specifiche dell'articolo",
  "Order_logisticsNo": "Numero di tracciamento",
  "order_shopping_firstname": "Nome",
  "Order_logisticsName": "Società di trasporto",
  "ItemPrice": "Importo dell'articolo",
  "inPayOrderAll": "Elenco di attesa per il pagamento",
  "payPrice": "Importo del pagamento",
  "shipping_add_success": "Creazione dell'indirizzo di spedizione riuscita",
  "match_goods": "Prodotti Popolari",
  "pay_code_refresh": "Aggiorna codice di pagamento",
  "pay_code_shixiao": "Il codice di pagamento QR è scaduto",
  "concactus_title": "Contattaci",
  "Search_items": "Cerca",
  "WebAutoLang": "La lingua consigliata dal tuo browser attuale è: {lang}. Vuoi passare a questa lingua?",
  "Services_Name": "Nome del servizio",
  "Services_Price": "Costo del servizio",
  "SwichLang": "Cambia lingua",
  "Services_Description": "Descrizione del servizio",
  "goodinfo_null": "Nessun prodotto disponibile",
  "goodinfo_null_des": "Puoi visualizzare altri prodotti di altre categorie",
  "notYetUseCode": "Non hai ancora utilizzato il codice promozionale",
  "guest_Login": "Accesso ospite",
  "billing_and_shipping": "Fatturazione e spedizione coincide",
  "select_coupon": "Seleziona Coupon",
  "select_gift": "Seleziona Regalo",
  "currentUseCode": "Codice promozionale utilizzato",
  "shipping_refresh": "Aggiorna lista",
  "Shipping_details": "Indirizzo di spedizione",
  "MyAccount_Newsletter": "Iscrizione",
  "MyAccount_Profile": "Profilo",
  "MyAccount_Wishlist": "Lista dei desideri",
  "See_all": "Tutto",
  "MyAccount_History": "Storico ordini",
  "bind_microsoft": "Bind Microsoft",
  "bind_twitter": "Bind Twitter",
  "bind_facebook": "Bind Facebook",
  "bind_wechat_code": "WeChat QR Code",
  "bind_wechat": "Bind WeChat",
  "bind_google": "Bind Google",
  "Wishlist_Empty": "Nessuna lista dei desideri",
  "discount_post_fee": "Sconto sulla spedizione",
  "ORDER_PART_PAID": "Pagamento parziale",
  "claimCouponeSuccess": "Coupon {name} recuperato con successo",
  "discount_kou": "{Sconto} di sconto",
  "claimCoupone": "Riscuoti",
  "cartPreviewSafety_messageinfo": "Sicure e veloci consegne all'indirizzo selezionato",
  "Order_No": "Numero d'ordine",
  "cartPreviewSafety": "Consegna Sicura",
  "Shipping": "Consegna",
  "MyAccount_MyShippingDetails_Street": "Via",
  "MyAccount_MyShippingDetails_HouseNumber": "Numero civico",
  "Shipping_title": "Indirizzo di consegna",
  "Offline_payment": "Pagamento offline",
  "shopName": "Nome del negozio",
  "Social": "Sociali",
  "SERVICE": "servizio",
  "onlineContact": "contatto online",
  "confirm": "Conferma",
  "closeOrder": "Annullare l'ordine",
  "closeOrderContext": "Sei sicuro di voler annullare l'ordine?",
  "Message_Read": "Letto",
  "close.order.success": "Ordine annullato con successo",
  "shippingAddress": "Indirizzo di spedizione",
  "Message": "Messaggio",
  "Message_Empty_Title": "Il tuo messaggio è vuoto",
  "MyAccount_Message": "Messaggio",
  "Message_Empty": "Nessun messaggio",
  "payment_order_note": "Nota ordine di pagamento",
  "go_to_see_prepid": "Clicca qui per visualizzare gli ordini non pagati",
  "operate": "Operazione",
  "removeCartItemContext": "Sei sicuro di voler rimuovere {title}？",
  "shippingItemQty": "Quantità di spedizione",
  "removeCartItem": "Rimuovere l'articolo",
  "shippingInfo": "Informazioni di spedizione",
  "Distributor_success": "Distributore creato con successo",
  "Distributor_apply": "Richiesta di distributore",
  "Distributor_Details": "Distributore",
  "DistributorSataus": "Stato",
  "Distributor_Details_Empty": "Nessun distributore trovato",
  "distributor.status.4": "Annullato",
  "distributor.status.1": "In Attesa di Approvazione",
  "Distributor_copy_url": "Copia Link di Distribuzione",
  "Order_Time": "Data dell'Ordine",
  "Order_User": "Utente che ha Ordinato",
  "Distributor_copy_success": "Copia Avvenuta con Successo",
  "distributor.status.3": "Pagato",
  "MyAccount_Distributor": "Distributore",
  "MyAccoubnt_Set_Distributor": "Richiesta di Distribuzione",
  "distributor.status.2": "In Attesa di Pagamento",
  "DistributorAmount": "Commissioni",
  "Distributor_shenheshibai": "Verifica distributore non superata",
  "Distributor_shenhezhong": "In attesa di verifica distributore",
  "Distributor_Order_Empty": "Nessun ordine di distribuzione disponibile",
  "NE": "Niger",
  "DJ": "Gibuti",
  "KP": "Corea del Nord",
  "US": "Stati Uniti",
  "LC": "Santa Lucia",
  "NL": "Paesi Bassi",
  "CD": "Congo (Rep. Dem. Del)",
  "IS": "Islanda",
  "MA": "Marocco",
  "GH": "Ghana",
  "KR": "Corea del Sud",
  "MK": "Macedonia (Ex Rep. Yugoslava)",
  "HT": "Haiti",
  "PF": "Polinesia Francese",
  "GA": "Gabon",
  "TD": "Ciad",
  "LB": "Libano",
  "CG": "Congo (Repubblica del)",
  "KG": "Kirghizistan",
  "TA": "Tristan da Cunha",
  "KW": "Kuwait",
  "TL": "Timor-Leste",
  "IN": "India",
  "NO": "Norvegia",
  "NG": "Nigeria",
  "AQ": "Antartide",
  "LY": "Libia",
  "NI": "Nicaragua",
  "TT": "Trinidad e Tobago",
  "HM": "Isole Heard e McDonald",
  "PY": "Paraguay",
  "BA": "Bosnia ed Erzegovina",
  "JP": "Giappone",
  "MD": "Moldova",
  "MT": "Malta",
  "RE": "Reunion",
  "UG": "Uganda",
  "SB": "Isole Solomon",
  "SL": "Sierra Leone",
  "CV": "Capo Verde",
  "SD": "Sudan",
  "FO": "Isole Faroe",
  "ZA": "Sudafrica",
  "TR": "Turchia",
  "FK": "Isole Falkland",
  "PA": "Panama",
  "GF": "Guiana francese",
  "TJ": "Tagikistan",
  "NC": "Nuova Caledonia",
  "PM": "Saint-Pierre e Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Bielorussia",
  "IM": "Isola di Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Isole Cook",
  "MH": "Isole Marshall",
  "CR": "Costa Rica",
  "HK": "Hong Kong SAR China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "Emirati Arabi Uniti",
  "GI": "Gibilterra",
  "CA": "Canada",
  "AX": "Isole Aland",
  "UY": "Uruguay",
  "WF": "Wallis e Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Russia",
  "PL": "Polonia",
  "FM": "Micronesia",
  "ET": "Etiopia",
  "EE": "Estonia",
  "SK": "Slovacchia",
  "AS": "Samoa Americane",
  "ZM": "Zambia",
  "AL": "Albania",
  "AT": "Austria",
  "VA": "Città del Vaticano",
  "TW": "Taiwan",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Sahara Occidentale",
  "MO": "Macao RAE Cinese",
  "MV": "Maldive",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Cile",
  "IL": "Israele",
  "GD": "Grenada",
  "WS": "Samoa",
  "SE": "Svezia",
  "GP": "Guadalupe",
  "YE": "Yemen",
  "GT": "Guatemala",
  "BG": "Bulgaria",
  "SJ": "Svalbard e Jan Mayen",
  "CO": "Colombia",
  "LS": "Lesotho",
  "LV": "Lettonia",
  "UM": "Isole minori esterne degli Stati Uniti",
  "MX": "Messico",
  "DO": "Repubblica Dominicana",
  "PE": "Perù",
  "HN": "Honduras",
  "TC": "Isole Turks e Caicos",
  "VI": "Isole Vergini Americane",
  "FJ": "Figi",
  "MP": "Isole Marianne Settentrionali",
  "AC": "Isola di Ascensione",
  "NA": "Namibia",
  "SZ": "Swaziland",
  "RW": "Ruanda",
  "BH": "Bahrein",
  "KN": "Saint Kitts e Nevis",
  "TN": "Tunisia",
  "AF": "Afghanistan",
  "VG": "Isole Vergini britanniche",
  "KE": "Kenya",
  "PK": "Pakistan",
  "GL": "Groenlandia",
  "SY": "Siria",
  "CU": "Cuba",
  "RS": "Serbia",
  "BF": "Burkina Faso",
  "BM": "Bermuda",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "Cina",
  "MF": "Saint Martin",
  "NF": "Isola Norfolk",
  "MZ": "Mozambico",
  "LU": "Lussemburgo",
  "TO": "Tonga",
  "GR": "Grecia",
  "SI": "Slovenia",
  "PW": "Palau",
  "TZ": "Tanzania",
  "IR": "Iran",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Territori Francesi del Sud",
  "PS": "Palestina",
  "SC": "Seychelles",
  "BT": "Bhutan",
  "JM": "Giamaica",
  "BR": "Brasile",
  "CH": "Svizzera",
  "SH": "Sant'Elena, Ascensione e Tristan da Cunha",
  "HU": "Ungheria",
  "TM": "Turkmenistan",
  "LT": "Lituania",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgia",
  "SA": "Arabia Saudita",
  "GB": "Regno Unito",
  "VE": "Venezuela",
  "MU": "Mauritius",
  "HR": "Croazia",
  "SR": "Suriname",
  "CM": "Camerun",
  "IQ": "Iraq",
  "BO": "Bolivia",
  "MN": "Mongolia",
  "DZ": "Algeria",
  "TK": "Tokelau",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "CC": "Cocos Islands",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Qatar",
  "AN": "Netherlands Antilles",
  "PN": "Pitcairn",
  "ES": "Spain",
  "VC": "Saint Vincent and the Grenadines",
  "AU": "Australia",
  "CX": "Christmas Island",
  "KM": "Comoros",
  "MR": "Mauritania",
  "FR": "France",
  "SG": "Singapore",
  "BV": "Bouvet Island",
  "PH": "Philippines",
  "CY": "Cyprus",
  "TV": "Tuvalu",
  "CF": "Central African Republic",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Ireland",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Equatorial Guinea",
  "NP": "Nepal",
  "BE": "Belgium",
  "GY": "Guyana",
  "DK": "Denmark",
  "MQ": "Martinique",
  "UZ": "Uzbekistan",
  "CI": "Ivory Coast",
  "ID": "Indonesia",
  "BJ": "Benin",
  "ST": "Sao Tome and Principe",
  "KH": "Cambodia",
  "KZ": "Kazakhstan",
  "MS": "Montserrat",
  "TH": "Thailand",
  "FI": "Finland",
  "ML": "Mali",
  "AM": "Armenia",
  "IT": "Italy",
  "NR": "Nauru",
  "PG": "Papua New Guinea",
  "ZW": "Zimbabwe",
  "JO": "Giordania",
  "OM": "Oman",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "Nuova Zelanda",
  "VU": "Vanuatu",
  "DE": "Germania",
  "CZ": "Repubblica Ceca",
  "DM": "Dominica",
  "KY": "Isole Cayman",
  "BW": "Botswana",
  "RO": "Romania",
  "PR": "Porto Rico",
  "AZ": "Azerbaijan",
  "IO": "Territorio britannico dell'Oceano Indiano",
  "UA": "Ucraina",
  "TG": "Togo",
  "MY": "Malesia",
  "AG": "Antigua e Barbuda",
  "EG": "Egitto",
  "GS": "Georgia del Sud e Isole Sandwich del Sud",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "Tutti",
  "post_state_country": "Costo di spedizione: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "Consegna a",
  "ShippingFee": "Costo di spedizione",
  "reviewOutOf": "{rating} stelle su 5",
  "product.pifa.label": "Compra {startnum} - {endnum} pezzi",
  "product.pifa.type.1": "Sconto",
  "Write_a_review": "Scrivi una recensione",
  "BasedOnTotalReviews": "Basato su {total} recensioni",
  "product.wholesale": "Prezzo all'ingrosso",
  "reviewMostRecent": "Recensioni più recenti",
  "product.pifa.type.2": "Prezzo unitario",
  "product.num.danwei": "pezzo",
  "good.shoppingDateLabel": "Data di spedizione",
  "good.shippingPeriod": "Spedizione entro i giorni",
  "emailError": "Formato email non valido",
  "addressNote": "Nota sull'indirizzo",
  "Concactus": "Contattaci",
  "addressMessage": "Assicurati che il tuo indirizzo sia corretto e preciso. Dopo aver effettuato l'acquisto non potrai più modificare l'indirizzo.",
  "showOrderSummary": "Riepilogo dell'ordine",
  "payment_method": "Modalità di pagamento",
  "emailNotNullError": "L'email non può essere vuota",
  "orderCreateLoading": "Creazione dell'ordine in corso...",
  "emailNote": "Contattaci",
  "emailMessage": "Assicurati che il tuo indirizzo email sia corretto e preciso. Ti invieremo una e-mail di conferma dell'ordine.",
  "payment_method_message": "Tutte le transazioni sono sicure e crittografate.",
  "go_buy_goods": "Continua ad acquistare",
  "tap_cancel_order": "Clicca qui per annullare l'ordine",
  "order_review": "Valutazione ordine",
  "Add_new_address": "Aggiungi nuovo indirizzo",
  "promo_code_type_3": "Buono regalo gratuito",
  "IdCardNotNull": "Si prega di inserire le informazioni sul nome reale",
  "UploadVideo": "Carica il video",
  "video": "Video",
  "UploadImage": "Carica l'immagine",
  "uploadImageing": "Caricamento in corso…",
  "BillingInfoNotNull": "Informazioni sulla fatturazione incomplete",
  "promo_code_type_2": "Buono",
  "UploadError": "Caricamento fallito",
  "promo_code_type_4": "Buono riduzione spese di spedizione",
  "image": "Immagine",
  "paymentMethodNotNull": "Si prega di selezionare un metodo di pagamento",
  "promo_code_type_1": "Coupon sconto",
  "shippingInfoNotNull": "Informazioni di spedizione incomplete",
  "reviewDetail": "Dettaglio recensione",
  "DeliveryCountry": "Area di consegna",
  "prompt_error": "Errore di promemoria",
  "save_review_success": "Recensione salvata con successo",
  "ORDER_COMPLETED": "completato",
  "crate_after_sales": "creare post-vendita",
  "Thank_You_Order": "Grazie per il tuo ordine!",
  "Thank_You_Order_sub": "Presto inizieremo a elaborare il tuo ordine e riceverai un'e-mail contenente informazioni sulla gestione dell'ordine.",
  "BootomCookieContext": "Questo sito web utilizza i cookie per aiutare il sito a funzionare correttamente e per aiutarci a capire come interagire con esso. Utilizziamo questi cookie per offrire un'esperienza utente personalizzata migliore. Se continui ad utilizzare questo sito we",
  "order_reivice_message": "Sei sicuro di aver ricevuto la merce?",
  "order_reivice_btn": "Conferma la ricezione",
  "order_reivice_label": "Ricezione dell'ordine",
  "order_reivice_success": "Conferma di ricezione riuscita",
  "collpase_show": "Mostra di più",
  "collpase_hide": "Nascondi",
  "CouponCode": "Codice Promozionale",
  "wechatPayScannerCode": "Si prega di utilizzare WeChat per scansionare il codice QR per il pagamento",
  "processing": "In elaborazione post-vendita",
  "finished": "Post-vendita completata",
  "login.showPrice": "Accedi per visualizzare il prezzo",
  "After_Sales_Unknown": "Stato post-vendita sconosciuto",
  "order_payment_list_null": "Nessun ordine da pagare",
  "Cancel": "Annulla",
  "thankyou_concat": "Se hai domande, contattaci"
}